
import {getDataInLocalStorage} from "@/utils/localStorage";
import {getRedNum} from "@/api/dilivery/redNum";
class nakedApproveRedNum {
    constructor() {
        this.total = 0
        this.pending = 0
        this.filling = 0
    }

    computeTotal() {
        this.total = this.pending + this.filling
    }

    empty() {
        this.total = 0
        this.fillNum = 0
        this.pendingNum = 0
    }
}
class InvoiceNum {
    constructor() {
        this.refundAudit = 0
        this.pending = 0
        this.refund = 0
    }
    empty() {
        this.refundAudit = 0
        this.pending = 0
        this.refund = 0
    }
}
class ContractNum {
    constructor() {
        this.audit = 0
        this.complements = 0
    }
    empty() {
        this.audit = 0
        this.complements = 0
    }
}

const state = {
    showLeftMenu: true,//控制侧边栏的折叠与展开
    reportRedDoltNum: 0,
    InvoiceRedDoltNum: new InvoiceNum(),
    ContractRedDoltNum: new ContractNum(),
    MailRedDoltNum: 0,
    RecordRedDoltNum: 0,
    nakedRedDoltNum: new nakedApproveRedNum(),
    courierRedDoltNum: 0,
    complementsRedDoltNum: 0,
    requestRedDoltNum: 0,
    analysisRedDoltNum: 0,
    requestMailRedDoltNum:0,
    submittedRedDoltNum: 0,
    claimRedDoltNum: 0,
    claimAuditRedDoltNum: 0,
    advanceRedDoltNum: 0,
    advanceAuditRedDoltNum: 0,
    arrangeRedDoltNum: 0,
    mailArrangeRedDoltNum:0,
    contractChangeRedDoltNum:0,
    teamAuditRedDoltNum: 0,
    terminateApplyDoltNum:0,
    signDoltNum: 0,
    offSetDoltNum:0
}
const getters = {
    getAuditRedDoltNum:(state) => {
        return state.ContractRedDoltNum.audit + state.RecordRedDoltNum + state.InvoiceRedDoltNum.refundAudit + state.analysisRedDoltNum + state.claimAuditRedDoltNum 
        + state.contractChangeRedDoltNum + state.terminateApplyDoltNum + state.advanceAuditRedDoltNum + state.offSetDoltNum + state.teamAuditRedDoltNum
    },
    getAmountRedDoltNum:(state) => {
        return state.InvoiceRedDoltNum.pending + state.InvoiceRedDoltNum.refund + state.courierRedDoltNum + state.claimRedDoltNum + state.advanceRedDoltNum
    },
    getShowLeftMenu: (state) => {
        return state.showLeftMenu
    },
    getNakedRedDoltNum: (state) => {
        state.nakedRedDoltNum.computeTotal()
        return state.nakedRedDoltNum
    },
    getContractRedDoltNum: (state) => {
        return state.ContractRedDoltNum
    },
    getInvoiceRedDoltNum: (state) => {
        return state.InvoiceRedDoltNum
    },
    getMailRedDoltNum: (state) => {
        return state.MailRedDoltNum
    },
    getRecordRedDoltNum: (state) => {
        return state.RecordRedDoltNum
    },
    getReportRedDoltNum: (state) => {
        return state.reportRedDoltNum
    },
    getCourierRedDoltNum: (state) => {
        return state.courierRedDoltNum
    },
    getComplementsRedDoltNum: (state) => {
        return state.complementsRedDoltNum
    },
    getRequestRedDoltNum: (state) => {
        return state.requestRedDoltNum
    },
    getMaterialRedDoltNum: (state) => {
        return state.requestRedDoltNum + state.requestMailRedDoltNum + state.arrangeRedDoltNum + state.mailArrangeRedDoltNum
    },
    getRequestMailRedDoltNum: (state) => {
        return state.requestMailRedDoltNum
    },
    getAnalysisRedDoltNum: (state) => {
        return state.analysisRedDoltNum
    },
    getSubmittedRedDoltNum: (state) => {
        return state.submittedRedDoltNum
    },
    getClaimRedDoltNum: (state) => {
        return state.claimRedDoltNum
    },
    getClaimAuditRedDoltNum: (state) => {
        return state.claimAuditRedDoltNum
    },
    getAdvanceAuditRedDoltNum: (state) => {
        return state.advanceAuditRedDoltNum
    },
    getAdvanceRedDoltNum: (state) => {
        return state.advanceRedDoltNum
    },
    getArrangeRedDoltNum: (state) => {
        return state.arrangeRedDoltNum
    },
    getMailArrangeRedDoltNum:(state) => {
        return state.mailArrangeRedDoltNum
    },
    getContractChangeDoltNum:(state) => {
        return state.contractChangeRedDoltNum
    },
    getTeamAuditDoltNum:(state) => {
        return state.teamAuditRedDoltNum
    },
    getOffSetDoltNum:(state) => {
        return state.offSetDoltNum
    },

    getTerminateApplyDoltNum:(state) => {
        return state.terminateApplyDoltNum
    },
    getSignRedDoltNum:(state) => {
        return state.signDoltNum
    },
}
const mutations = {
    setInit(state){
        state.nakedRedDoltNum.empty()
        state.reportRedDoltNum=0
        state.InvoiceRedDoltNum.empty()
        state.ContractRedDoltNum.empty()
        state.MailRedDoltNum = 0
        state.RecordRedDoltNum = 0
        state.courierRedDoltNum = 0
        state.requestRedDoltNum = 0
        state.requestMailRedDoltNum = 0
        state.complementsRedDoltNum = 0
        state.submittedRedDoltNum = 0
        state.claimRedDoltNum = 0
        state.claimAuditRedDoltNum = 0
        state.advanceRedDoltNum = 0
        state.advanceAuditRedDoltNum = 0
        state.arrangeRedDoltNum = 0
        state.mailArrangeRedDoltNum = 0
        state.analysisRedDoltNum = 0
        state.contractChangeRedDoltNum = 0
        state.terminateApplyDoltNum = 0
        state.signDoltNum = 0
        state.offSetDoltNum = 0
    },
    setShowLeftMenu: (state) => {
        state.showLeftMenu = !state.showLeftMenu
    },
    setContractRedDoltNum(state, data) {
        state.ContractRedDoltNum[data.type] = data.num
    },
    setInvoiceRedDoltNum(state, data) {
        state.InvoiceRedDoltNum[data.type] = data.num
    },
    setMailRedDoltNum(state, data) {
        if (!data.type) {
            state.MailRedDoltNum = data.num
        }
    },
    setRecordRedDoltNum(state, data) {
        if (!data.type) {
            state.RecordRedDoltNum = data.num
        }
    },
    setReportRedDoltNum(state, data) {
        if (!data.type) {
            state.reportRedDoltNum = data.num
        }
    },
    setCourierRedDoltNum(state, data) {
        if (!data.type) {
            state.courierRedDoltNum = data.num
        }
    },
    setComplementsRedDoltNum(state, data) {
        if (!data.type) {
            state.complementsRedDoltNum = data.num
        }
    },
    setRequestRedDoltNum(state, data) {
        if (!data.type) {
            state.requestRedDoltNum = data.num
        }
    },
    setAnalysisRedDoltNum(state, data) {
        if (!data.type) {
            state.analysisRedDoltNum = data.num
        }
    },
    setRequestMailRedDoltNum(state, data) {
        if (!data.type) {
            state.requestMailRedDoltNum = data.num
        }
    },
    setSubmittedRedDoltNum(state, data) {
        if (!data.type) {
            state.submittedRedDoltNum = data.num
        }
    },
    setClaimRedDoltNum(state, data) {
        if (!data.type) {
            state.claimRedDoltNum = data.num
        }
    },
    setClaimAuditRedDoltNum(state, data) {
        if (!data.type) {
            state.claimAuditRedDoltNum = data.num
        }
    },
    setAdvanceAuditRedDoltNum(state, data) {
        if (!data.type) {
            state.advanceAuditRedDoltNum = data.num
        }
    },
    setArrangeRedDoltNum(state, data) {
        if (!data.type) {
            state.arrangeRedDoltNum = data.num
        }
    },
    setMailArrangeDoltNum(state, data){
        if (!data.type) {
            state.mailArrangeRedDoltNum = data.num
        }
    },
    setContractChangeDoltNum(state, data){
        if (!data.type) {
            state.contractChangeRedDoltNum = data.num
        }
    },
    setTeamAuditDoltNum(state, data){
        if (!data.type) {
            state.teamAuditRedDoltNum = data.num
        }
    },
    setOffSetDoltNum(state, data){
        if (!data.type) {
            state.offSetDoltNum = data.num
        }
    },

    setTerminateApplyDoltNum(state, data){
        if (!data.type) {
            state.terminateApplyDoltNum = data.num
        }
    },
    setSignDoltNum(state, data){
        if (!data.type) {
            state.signDoltNum = data.num
        }
    },
    setAdvanceRedDoltNum(state, data) {
        if (!data.type) {
            state.advanceRedDoltNum = data.num
        }
    },
}
const actions = {
    //获取报告、裸测未审批条数
    async getRedDoltNum({commit}, info) {
        try{
            const res = await getRedNum(info.data, info.sys)
            if (res.code === 200) {
                commit(info.setRedDoltName, {num: parseInt(res.data), type: info.type})
            }
        } catch (error) {
            console.log(error);
        }
    }
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
